/**
 * Get array of unique values from array (Using shallow comparison)
 *
 * @template T
 *
 * @param {Array<T>} array
 *
 * @example
 * extractUniqueValuesFromArray([1, 1, 2, 'a', 'b', 'b']);
 * // returns [1, 2, 'a', 'b']
 *
 * @return {*} Array<T>
 */
export var extractUniqueValuesFromArray = function (array) { return array.filter(function (item, index, self) { return self.indexOf(item) === index; }); };
//# sourceMappingURL=extractUniqueValuesFromArray.js.map